import React from 'react';
import { Route, Switch } from 'react-router-dom/cjs/react-router-dom.min';
import { sideBarItems } from 'utils/appDefinitions';
import './EuropaNew.css';
import DefaultDashboard from './Dashboards/DefaultDashboard';
import datasetParams_SalesAndAttendance from './datasetParams/SalesAndAttendance/datasetParams_SalesAndAttendance';
import datasetParams_Sales_s from './datasetParams/Sales/datasetParams_Sales_s';
import datasetParams_Sales_s_allYears from './datasetParams/Sales/datasetParams_Sales_s_allYears';
import datasetParams_Sales_xl from './datasetParams/Sales/datasetParams_Sales_xl';
import datasetParams_SalesBySOR_s from './datasetParams/SalesBySOR/datasetParams_SalesBySOR_s';
import datasetParams_SalesBySOR_s_allYears from './datasetParams/SalesBySOR/datasetParams_SalesBySOR_s_allYears';
import datasetParams_SalesBySOR_xl from './datasetParams/SalesBySOR/datasetParams_SalesBySOR_xl';
import datasetParams_Attendance_s from './datasetParams/Attendance/datasetParams_Attendance_s';
import datasetParams_Attendance_s_allYears from './datasetParams/Attendance/datasetParams_Attendance_s_allYears';
import datasetParams_Attendance_xl from './datasetParams/Attendance/datasetParams_Attendance_xl';
import datasetParams_DCO from './datasetParams/DCO/datasetParams_DCO';
import datasetParams_Web from './datasetParams/Web/datasetParams_Web';
import datasetParams_Web_pageLandings from './datasetParams/Web/datasetParams_Web_pageLandings';
import datasetParams_Web_pageVisits from './datasetParams/Web/datasetParams_Web_pageVisits';
import datasetParams_Web_Email from './datasetParams/Web/datasetParams_Web_Email';
import SalesAndAttendance from './Dashboards/SalesAndAttendance';

const EuropaNewContainer = () => {
  const routes = [
    {
      group: 'Sales',
      name: 'Sales - S',
      params: datasetParams_Sales_s,
    },
    {
      group: 'Sales',
      name: 'Sales - S - All Years',
      params: datasetParams_Sales_s_allYears,
    },
    {
      group: 'Sales',
      name: 'Sales - XL',
      params: datasetParams_Sales_xl,
    },
    {
      group: 'Sales',
      name: 'Sales By SOR - S',
      params: datasetParams_SalesBySOR_s,
    },
    {
      group: 'Sales',
      name: 'Sales By SOR - S - All Years',
      params: datasetParams_SalesBySOR_s_allYears,
    },
    {
      group: 'Sales',
      name: 'Sales By SOR - XL',
      params: datasetParams_SalesBySOR_xl,
    },
    {
      group: 'Attendance',
      name: 'Attendance - S',
      params: datasetParams_Attendance_s,
    },
    {
      group: 'Attendance',
      name: 'Attendance - S - All Years',
      params: datasetParams_Attendance_s_allYears,
    },
    {
      group: 'Attendance',
      name: 'Attendance - XL',
      params: datasetParams_Attendance_xl,
    },
    {
      group: 'DCO',
      name: 'Sales & Bookings',
      params: datasetParams_DCO,
    },
    {
      group: 'Web',
      name: 'Web Traffic',
      params: datasetParams_Web,
    },
    {
      group: 'Web',
      name: 'Web Traffic - Page Visits',
      params: datasetParams_Web_pageVisits,
    },
    {
      group: 'Web',
      name: 'Web Traffic - Page Landings',
      params: datasetParams_Web_pageLandings,
    },
    {
      group: 'Web',
      name: 'Email',
      params: datasetParams_Web_Email,
    },
  ];

  return (
    <div className="EuropaNew">
      <Switch>
        {routes.map((route) => (
          <Route key={route.group + route.name} exact path={`/${route.group}/${route.name.replaceAll(' ', '_')}`}>
            <DefaultDashboard
              title={route.name}
              subModule={route.name.replaceAll(' - ', '_').replaceAll(' ', '_')}
              datasetParams={route.params}
              excludeFilters={['Date', 'Year', 'YearMonth']}
            />
          </Route>
        ))}
        <Route exact path="/Sales/Sales_and_Attendance">
          <SalesAndAttendance
            title="Sales and Attendance"
            subModule="Sales_and_Attendance"
            datasetParams={datasetParams_SalesAndAttendance}
            excludeFilters={['Date', 'Year', 'YearMonth']}
          />
        </Route>
      </Switch>
    </div>
  );
};

export default EuropaNewContainer;
